import { Stack, Box, Button, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import {Header} from 'components/Modal'

import ModelSteps from './components';
import videos from './videos'

const Chromecast = ({ device }) => {
  const { t, i18n} = useTranslation()
  const navigate = useNavigate()
  const theme = useTheme()
  const videoLink = videos[`chromecast${device.standalone ? '_standalone' : ''}`]?.[i18n.language]
  return (
    <Stack sx={{ width: 500, fontSize: 13 }}>
      <ModelSteps nbSteps={1} step={0} onSelect={() => { navigate('..') }}>
        <Header icon={<i className="fa-solid fa-gear" />} title={t('stream-cast.config.chromecast.block_1_title')} />
        {
          Boolean(videoLink) && (
            <Stack gap={1} mb={2}>
              <Typography component="span" sx={{ fontSize: 13, textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: t('stream-cast.config.device_type.video_disclaimer') }} />
              <Button onClick={() => window.open(videoLink, '_blank')} size="small" variant="contained" sx={{alignSelf: 'center'}}>
                <i className="fa-solid fa-play" style={{ marginRight: 5, marginTop: 2 }} />
                {t('ui_elements.play_video')}
              </Button>
              <Stack alignItems={'center'} mt={2}>
                <Box sx={{width: '75%', height: '1px', backgroundColor: theme.palette.grey[200]}} />
              </Stack>
            </Stack>
          )
        }
        <Box dangerouslySetInnerHTML={{ __html: t('stream-cast.config.chromecast.block_1', { ssid_name: 'wifirst-devices', psk: process.env.REACT_APP_CHROMECAST_PASSWORD }) }} />
        <Box dangerouslySetInnerHTML={{ __html: t(`stream-cast.config.chromecast.block_1${device.standalone ? '_standalone' : '_full'}`) }} />
      </ModelSteps>
    </Stack>
  )
}

export default Chromecast